var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lot-item",attrs:{"title":_vm.lot.lotName}},[_c('span',{staticClass:"name"},[_vm._v(_vm._s(_vm.lot.lotName))])])
}
var staticRenderFns = []

export { render, staticRenderFns }